import React from 'react'
import RemoveBgPreviewToolbar from './RemoveBgPreviewToolbar'
import RemoveBgPreviewCanvas from './RemoveBgPreviewCanvas'

function RemoveBgPreviewPanel({editor, status, error, retry}) {
    return (
        <div className="RemoveBgEditor__PreviewPanel">
            <RemoveBgPreviewToolbar
                ready={editor.ready}
                tool={editor.tool}
                onSetTool={editor.setTool}
                canUndo={editor.canUndo}
                canRedo={editor.canRedo}
                onUndo={editor.undo}
                onRedo={editor.redo}
                zoomPercent={editor.zoomPercent}
                onZoomIn={editor.zoomIn}
                onZoomOut={editor.zoomOut}
            />
            <RemoveBgPreviewCanvas
                canvasRef={editor.canvasRef}
                containerRef={editor.containerRef}
                status={status}
                error={error}
                retry={retry}
                ready={editor.ready}
                tool={editor.tool}
                mode={editor.mode}
                brushSize={editor.brushSize}
                zoom={editor.zoom}
                onPointerDown={editor.handleCanvasPointerDown}
                onPointerMove={editor.handleCanvasPointerMove}
                onPointerUp={editor.handleCanvasPointerUp}
                onWheel={editor.handleWheel}
            />
        </div>
    )
}

export default RemoveBgPreviewPanel
